import Vue from 'vue'
import { Course } from '../entities/Course'
import { Appointment } from '@/entities/Appointment'

export class CourseService {
  static getCourseById (id:number) {
    return Vue.axios.get<Course>(`/courses/${id}`)
  }
}
